import { message } from 'antd';

/**
 * Inicia a verificação periódica do status do OCR para um capítulo.
 * @param chapterId O ID do capítulo que está sendo processado.
 * @param bookId O ID do livro.
 * @param editionId O ID da edição.
 */
//
export function pollOcrStatus(chapterId: string, bookId: string, editionId: string) {
   message.info('Processando texto do PDF, por favor aguarde...', 0);

  const intervalId = setInterval(async () => {
    try {
      const apiUrl = `/api/v1/ocr-status/${chapterId}`;
      console.log("Chamando OCR Status URL:", apiUrl);

      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`Erro na API: ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log('Status do OCR recebido:', data.status);

      if (data.status === 'COMPLETED') {
        clearInterval(intervalId);
        message.destroy();
        message.success('Texto OCR gerado automaticamente!');
      } else if (data.status === 'FAILED') {
        clearInterval(intervalId);
        message.destroy();
        message.error('Erro ao processar o texto do PDF.');
      }

    } catch (error) {
      clearInterval(intervalId);
       message.destroy();
      // message.error('Erro de comunicação ao verificar o status do OCR.');
      // console.error('❌ Erro durante o polling:', error);
    }
  }, 5000);
}
